import React, { useState, useCallback } from "react";
import Image from "next/future/image";
import { useRouter } from "next/router";
import { useEffect } from "react";

const Policy = () => {
  const [state, setState] = useState();
  const router = useRouter();

  const getIdFromUrl = useCallback(() => {
    return router.asPath.substring(router.asPath.lastIndexOf("#") + 1);
  }, [router]);

  useEffect(() => {
    setState(getIdFromUrl());
  }, [getIdFromUrl]);

  return (
    <div className="flex mt-16 flex-col sm:flex-row bg-slate-50 text-[#141414]">
      <div className="leading-[3.5rem] sm:p-1 sm:pt-[8rem] items-center w-[100%] sm:w-[70%] hidden sm:flex h-[70%] justify-center">
        <div className="flex-col leading-[3.5rem] sm:p-1 w-[100%] sm:w-[70%] hidden sm:flex h-[70%] ml-20 ">
          <div className="w-[1.6rem] lg:ml-[3rem]">
            <Image
              src="/logo.png"
              alt="Itmtb"
              height="50"
              width="50"
              priority={true}
            />
          </div>
          <a
            className={`${
              state === "gen-info" ? "text-[#F19441]" : "text-black"
            } policy-menu`}
            href="#gen-info"
            onClick={() => setState("gen-info")}
          >
            General Information
          </a>
          <a
            className={`${
              state === "info-col" ? "text-[#F19441]" : "text-black"
            } policy-menu`}
            href="#info-col"
            onClick={() => setState("info-col")}
          >
            Information Collected
          </a>
          <a
            className={`${
              state === "col-method" ? "text-[#F19441]" : "text-black"
            } policy-menu`}
            href="#col-method"
            onClick={() => setState("col-method")}
          >
            Collection Method
          </a>
          <a
            className={`${
              state === "info-use" ? "text-[#F19441]" : "text-black"
            } policy-menu`}
            href="#info-use"
            onClick={() => setState("info-use")}
          >
            Information Usage
          </a>
          <a
            className={`${
              state === "info-share" ? "text-[#F19441]" : "text-black"
            } policy-menu`}
            href="#info-share"
            onClick={() => setState("info-share")}
          >
            Information sharing
          </a>
          <a
            className={`${
              state === "your-choices" ? "text-[#F19441]" : "text-black"
            } policy-menu`}
            href="#your-choices"
            onClick={() => setState("your-choices")}
          >
            Your choices
          </a>
          <a
            className={`${
              state === "contact-info" ? "text-[#F19441]" : "text-black"
            } policy-menu`}
            href="#contact-info"
            onClick={() => setState("contact-info")}
          >
            Contact Information
          </a>
        </div>
      </div>
      <div className="w-[100%] sm:w-[100%] p-2 sm:p-10 h-[100%] sm:h-screen overflow-y-auto pt-[36px] sm:pt-[100px] scrollbar-hide">
        <div className="row">
          <h1 className="font-semibold text-4xl ">Privacy Policy</h1>
        </div>
        <p className="policy-title" id="gen-info">
          General information
        </p>
        <p className="policy-body">
          Itmtb respects your privacy. This Privacy Policy provides succinctly
          the manner your data is collected and used by itmtb on the Site. As a
          visitor to the Platform, you are advised to please read the Privacy
          Policy carefully. By accessing the services provided by the Site you
          agree to the collection and use of your data by itmtb in the manner
          provided in this Privacy Policy.{" "}
        </p>
        <p className="policy-title" id="info-col">
          Information collected
        </p>
        <p className="policy-body">
          As part of the registration process on the Site, itmtb may collect the
          following personally identifiable information about you: Name
          including first and last name, alternate email address, mobile phone
          number and contact details, Postal code, Demographic profile (like
          your age, gender, occupation, education, address etc.) and information
          about the pages on the site you visit/access, the links you click on
          the site, the number of times you access the page and any such
          browsing information.{" "}
        </p>
        <p className="policy-title" id="col-method">
          Collection method
        </p>
        <p className="policy-body">
          {" "}
          Itmtb will collect personally identifiable information about you only
          as part of a voluntary registration process, on-line survey or any
          combination thereof. The Platform may contain links to other Websites.
          itmtb is not responsible for the privacy practices of such Web sites
          which it does not own, manage or control. The Site and third-party
          vendors, including Google, use first-party cookies (such as the Google
          Analytics cookie) and third-party cookies (such as the DoubleClick
          cookie) together to inform, optimize, and serve ads based on someone's
          past visits to the Site.
        </p>
        <p className="policy-title" id="info-use">
          Information usage
        </p>
        <p className="policy-body">
          {" "}
          Itmtb will use your personal information to provide personalized
          features to you on the Site and to provide for promotional offers to
          you through the Site and other channels. itmtb will also provide this
          information to its business associates and partners to get in touch
          with you when necessary to provide the services requested by you.
          itmtb will use this information to preserve transaction history as
          governed by existing law or policy. itmtb may also use contact
          information internally to direct its efforts for product improvement,
          to contact you as a survey respondent, to notify you if you win any
          contest; and to send you promotional materials from its contest
          sponsors or advertisers. itmtb will also use this information to serve
          various promotional and advertising materials to you via display
          advertisements through the Google Ad network on third party websites.
          You can opt-out of Google Analytics for Display Advertising and
          customize Google Display Network ads using the Ads Preferences
          Manager. Information about Customers on an aggregate (excluding any
          information that may identify you specifically) covering Customer
          transaction data and Customer demographic and location data may be
          provided to partners of itmtb for the purpose of creating additional
          features on the website, creating appropriate merchandising or
          creating new products and services and conducting marketing research
          and statistical analysis of customer behaviour and transactions. itmtb
          may use external, third-party API to provide some services. In these
          cases, itmtb will not have any control over data usage by these
          third-party APIs. itmtb will inform users of such instances and users
          may choose not to use such facilities. Currently, we use Telegram API
          to provide any telegram notifications if chosen by the user. Please
          refer to the documentation of third-party APIs for their data usage
          policy.
        </p>

        <p className="policy-title" id="info-share">
          Information sharing
        </p>
        <p className="policy-body">
          {" "}
          Itmtb will not use your financial information for any purpose other
          than to complete a transaction with you. itmtb does not rent, sell or
          share your personal information and will not disclose any of your
          personally identifiable information to third parties. In cases where
          it has your permission to provide products or services, you've
          requested and such information is necessary to provide these products
          or services with the information may be shared with itmtb’s business
          associates and partners. itmtb may, however, share consumer
          information on an aggregate with its partners or third parties where
          it deems necessary. In addition, itmtb may use this information for
          promotional offers, to help investigate, prevent or take action
          regarding unlawful and illegal activities, suspected fraud, potential
          threat to the safety or security of any person, violations of the
          Site's terms of use or to defend against legal claims; special
          circumstances such as compliance with subpoenas, court orders,
          requests/order from legal authorities or law enforcement agencies
          requiring such disclosure.
        </p>

        <p className="policy-title" id="your-choices">
          Your choices
        </p>
        <p className="policy-body">
          To protect against the loss, misuse and alteration of the information
          under its control, itmtb has in place appropriate physical, electronic
          and managerial procedures. For example, itmtb servers are accessible
          only to authorized personnel and your information is shared with
          employees and authorised personnel on a need to know basis to complete
          the transaction and to provide the services requested by you. Although
          itmtb will endeavour to safeguard the confidentiality of your
          personally identifiable information, transmissions made by means of
          the Internet cannot be made absolutely secure. By using this site, you
          agree that itmtb will have no liability for disclosure of your
          information due to errors in transmission or unauthorized acts of
          third parties.
        </p>
        <br />
        <br />
        <p>
          If you wish that we delete all your data that we have with us,
          collected in the course of your interaction with our platforms, and in
          line with our privacy policy, write to hello@itmtb from your
          registered email address. The subject line should mention "Delete my
          data." Within 10 days of receiving your data deletion request, we will
          complete the deletion of all data collected through your usage of our
          platforms. We will send you a confirmation email once your data is
          deleted. If you want to know the status of your data deletion request,
          please write to hello@itmtb.com. The subject line shall say, "Update
          on data deletion request."
        </p>
        <p className="policy-title" id="contact-info">
          Contact
        </p>
        <p className="policy-body">hello@itmtb.com</p>
      </div>
    </div>
  );
};

export default Policy;
